import { Navigate } from "react-router-dom";

const RedirectBananaStandPage = () => <Navigate to="/banana-stand" replace />;

export default RedirectBananaStandPage;
